export class AnalyticsChartsService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async getMany(reportId, skip = 0, take = 100) {
        const { items } = await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `/reports/${reportId}/charts?$skip=${skip}&$take=${take}`,
        });
        return { charts: items };
    }
    async set(reportId, chart) {
        const resource = await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'set',
            type: 'application/vnd.iris.chart+json',
            uri: `/reports/${reportId}/charts`,
            resource: chart,
        });
        return resource.id;
    }
    async setMany(reportId, charts) {
        const resources = await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'set',
            type: 'application/vnd.lime.collection+json',
            uri: `/reports/${reportId}/charts`,
            resource: {
                itemType: 'application/vnd.iris.chart+json',
                items: charts,
            },
        });
        return resources.items.map(r => r.id);
    }
    async delete(reportId, chartId) {
        return await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'delete',
            uri: `/reports/${reportId}/charts/${chartId}`,
        });
    }
}
AnalyticsChartsService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
